import React from 'react';
import styled from 'styled-components';
import Particle from '../Components/MainParticle';
import Title from '../Components/Title';
import ImageSection from '../Components/ImageSection';
import ServiceSection from '../Components/ServiceSection';
import { MainLayout } from '../styles/Layouts';
import ReviewsSection from '../Components/ReviewsSection';

function AboutPage() {
  return (
    <MainLayout>
      <AboutStyled>
        <Particle />
        <Title title={'About Me'} span={'About Me'} />
        <ImageSection />
        <Particle />
        <ServiceSection />

        <ReviewsSection />
      </AboutStyled>
    </MainLayout>
  );
}

const AboutStyled = styled.section``;

export default AboutPage;
